import api from './api';

export interface DreDetalhe {
    id: number;
    nome: string;
    valor: number;
}

export interface DreSecao {
    total: number;
    detalhes: DreDetalhe[];
}

export interface DreData {
    periodo: string;
    regime: 'competencia';
    receitas: DreSecao;
    custos: DreSecao;
    despesas_operacionais: DreSecao;
    despesas_financeiras: DreSecao;
    margem_contribuicao: number;
    resultadoLiquido: number;
    /** @deprecated mantido por compatibilidade — usar custos + despesas_operacionais + despesas_financeiras */
    despesas?: DreSecao;
}

export const dreService = {
    get: async (mes?: string, ano?: string): Promise<DreData> => {
        const response = await api.get<DreData>('/dre', { params: { mes, ano } });
        return response.data;
    }
};
